import * as React from 'react';
import { Link } from 'react-router-dom';
import PromoCard from '../../components/PromoCard';

export default () => (
  <PromoCard
    image_url="/images/shipment.png"
    title="Sell coffee on the Filtru app"
    subtitle="With a single tap of a button, your customers can order coffee and brew it, giving you detailed feedback and review"
  >
    <p className="ma0 mt3 mt4-l">
      <Link
        to="/products"
        className="f5 link dim br-pill bg-black-10 hover-bg-black-20 ph4 pv3 mh1 dib bw0 pointer black b"
      >
        Get Started
      </Link>
    </p>
  </PromoCard>
);
